Layout.store.state = {};